import { ColumnType, HumiColumnConfig } from '@import/interfaces';

/**
 * Check if a HumiColumn is required with other HumiColumns with values or from required by the config
 */
export const isRequiredWith = (
    humiColumn: ColumnType,
    humiColumns: ColumnType[],
    columnRequirementConfig: HumiColumnConfig
): boolean => {
    const requiredByConfig = humiColumn.requiredWith?.some(
        (requiredWith: string) => columnRequirementConfig[requiredWith]
    );
    const conditionallyRequired = humiColumns
        .filter(
            (column: ColumnType) =>
                column.requiredWith &&
                humiColumn.requiredWith.some((requiredColumn) => column.serializeName.includes(requiredColumn))
        )
        .some((requiredColumns: ColumnType) => requiredColumns.csvColumn);
    return requiredByConfig || conditionallyRequired;
};
